export default function WeatherCard({ weather, eventDate, loading }) {
  if (loading) {
    return (
      <div className="rounded-xl border bg-sky-50 border-sky-200 p-4 flex items-center justify-center min-h-[120px]">
        <div className="flex items-center gap-2 text-sky-600 text-sm">
          <div className="w-4 h-4 border-2 border-sky-400 border-t-transparent rounded-full animate-spin" />
          Loading forecast...
        </div>
      </div>
    );
  }

  if (!weather) {
    return (
      <div className="rounded-xl border bg-sky-50 border-sky-200 p-4 text-center text-sm text-sky-600">
        <p className="text-2xl mb-1">🌤️</p>
        <p>Select your event date and enter your city or ZIP to see the forecast.</p>
      </div>
    );
  }

  const formattedDate = eventDate
    ? new Date(eventDate + "T12:00:00").toLocaleDateString("en-US", {
        weekday: "long", month: "long", day: "numeric", year: "numeric",
      })
    : "";

  const rainChance = weather.weather_rain_chance;
  const isHighRain = rainChance !== null && rainChance > 60;
  const isModerateRain = rainChance !== null && rainChance > 30 && rainChance <= 60;

  const cardBg = isHighRain
    ? "bg-orange-50 border-orange-200"
    : isModerateRain
    ? "bg-yellow-50 border-yellow-200"
    : "bg-sky-50 border-sky-200";

  const msgColor = isHighRain
    ? "text-orange-700"
    : isModerateRain
    ? "text-yellow-700"
    : "text-sky-700";

  return (
    <div className={`rounded-xl border p-4 space-y-3 ${cardBg}`}>
      <div className="flex items-center gap-2">
        <span className="text-lg">🎉</span>
        <h3 className="font-semibold text-sm text-gray-700">Event Day Forecast</h3>
      </div>

      {formattedDate && (
        <p className="text-xs text-gray-500">{formattedDate}</p>
      )}

      {weather.status === "unavailable" || weather.status === "out_of_range" ? (
        <p className={`text-sm font-medium ${msgColor}`}>{weather.weather_message}</p>
      ) : (
        <>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1.5 text-sm font-semibold text-gray-800">
              <span className="text-base">🌡️</span>
              High {weather.weather_high_temp}°F
            </div>
            <div className="flex items-center gap-1.5 text-sm font-semibold text-gray-800">
              <span className="text-base">🌧️</span>
              {weather.weather_rain_chance}% rain
            </div>
          </div>
          <p className={`text-xs font-medium ${msgColor}`}>{weather.weather_message}</p>
        </>
      )}
    </div>
  );
}